module.exports = __webpack_public_path__ + "static/media/1013093.9185e684.png";